// extracted by mini-css-extract-plugin
export var base = "_1t-0";
export var updateBanner = "_1t-1";